import { Flex, Icon, Input } from '@chakra-ui/react';
import { RiSearchLine } from 'react-icons/ri';
import { search } from 'ss-search';

type ControlsData = {
  page: number;
  perPage: number;
  totalPage: number;
};
type ProdutoData = {
  id: string;
  categoria: string;
  cod_barras: string;
  complementos: string;
  descricao: string;
  nome: string;
  promocao: string;
  qtd: number;
  status: string;
  url_imagem: string;
  id_classif: number;
	valor: number;
	total: number;
	valorFormatted: string;
	totalFormatted: string;
};
interface DataTableSearchParams {
  produtos: ProdutoData[];
  setPesqProdutos: (clientes: ProdutoData[]) => void;
  controls: ControlsData;
  setControls: (control: ControlsData) => void;
  handleUpdateList: (
    page: number,
    perPage: number,
    produtos: ProdutoData[],
  ) => void;
}

const DataTableSearch: React.FC<DataTableSearchParams> = ({
  produtos,
  setPesqProdutos,
  controls,
  setControls,
  handleUpdateList,
}) => {
  function handlePesquisa(event: string) {
    const texto = event;

    if (texto === '' || texto === ' ') {
      setPesqProdutos(produtos);

      setControls({
        ...controls,
        page: 1,
        totalPage: Math.ceil(produtos.length / controls.perPage),
      });
      handleUpdateList(1, controls.perPage, produtos);
      return;
    }

		const searchKeys = ['cod_barras', 'id', 'nome', 'doc', 'descricao', 'valor', 'total', 'status'];
    const results = search(produtos, searchKeys, texto) as ProdutoData[];

    setPesqProdutos(results);
    setControls({
      ...controls,
      page: 1,
      totalPage: Math.ceil(results.length / controls.perPage),
    });

    handleUpdateList(1, controls.perPage, results);
  }

  return (
		<Flex as="form" ml={["0", "0", "4"]}>
      <Flex
        as="label"
        flex="1"
        py="2"
        pl="2"
        pr="6"
        maxWidth={400}
        alignSelf="center"
        color="gray.900"
        position="relative"
        bg="gray.50"
        borderRadius="full"
      >
        <Input
          color="gray.900"
          variant="unstyled"
          px="4"
          mr="4"
          placeholder="Pesquisar"
          _placeholder={{ color: 'gray.400' }}
          onChange={e => handlePesquisa(e.target.value)}
        />

        <Icon as={RiSearchLine} fontSize="20" color="blue.500" />
      </Flex>
    </Flex>
  );
};

export default DataTableSearch;
